'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NestedSection = undefined;

var _templateObject = _taggedTemplateLiteral(['\n    ', '\n    ', ';\n\n    & > ', ' {\n        display: grid;\n        grid-template-columns: 1fr;\n        grid-gap: 1em 2em;\n\n        @media ', ' {\n          grid-template-columns: 1fr 1fr;\n        }\n\n        & > ', ' {\n            ', '\n            padding: 0;\n            & > ', ' {\n              margin: auto;\n              max-width: none;\n            }\n        }\n    }\n'], ['\n    ', '\n    ', ';\n\n    & > ', ' {\n        display: grid;\n        grid-template-columns: 1fr;\n        grid-gap: 1em 2em;\n\n        @media ', ' {\n          grid-template-columns: 1fr 1fr;\n        }\n\n        & > ', ' {\n            ', '\n            padding: 0;\n            & > ', ' {\n              margin: auto;\n              max-width: none;\n            }\n        }\n    }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Section = require('./Section');

var _SectionContent = require('./SectionContent');

var _styles = require('./styles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
/*:: import type {ComponentType} from 'react' */


var NestedSection = exports.NestedSection = (0, _styledComponents2.default)(function (props) {
  return _react2.default.createElement(
    'div',
    { className: props.className },
    _react2.default.createElement(
      _SectionContent.SectionContent,
      null,
      props.children
    )
  );
})(_templateObject, _Section.sectionStyles, _Section.colorScheme, _SectionContent.SectionContent, _styles.styles.media.tablet, _Section.Section, _Section.colorScheme, _SectionContent.SectionContent);
NestedSection.displayName = 'NestedSection';


//////////////////
// WEBPACK FOOTER
// ../tutellus-ui/lib/NestedSection.js
// module id = 643
// module chunks = 0